import React, { useEffect } from "react"
import axios from "axios"
import { authStorage } from "../utils/storage"

interface AuthInitializerProps {
	children: React.ReactNode
}

/**
 * Восстанавливает сессию через refresh token из httpOnly cookie в фоне.
 * Контент показывается сразу — без блокирующего лоадера, загрузка быстрее.
 * Редирект на /auth/login только с защищённых страниц (см. api interceptor).
 */
export const AuthInitializer: React.FC<AuthInitializerProps> = ({ children }) => {
	useEffect(() => {
		if (authStorage.hasToken()) return

		const apiUrl = process.env.REACT_APP_API_URL || "https://api.bluecards.ru"
		const baseUrl = apiUrl.endsWith("/api") ? apiUrl : apiUrl.replace(/\/+$/, "") + "/api"

		axios
			.post<{ accessToken: string }>(
				`${baseUrl}/auth/refresh`,
				{},
				{ withCredentials: true, headers: { "Content-Type": "application/json" } }
			)
			.then((res) => {
				if (res.data.accessToken) authStorage.setAccessToken(res.data.accessToken)
			})
			.catch(() => authStorage.clearAuth())
	}, [])

	return <>{children}</>
}

